export let TaxType=/*#__PURE__*/function(TaxType){TaxType["Fixed"]="Fixed";TaxType["Dynamic"]="Dynamic";return TaxType;}({});